// @ts-nocheck
import React, { useState, useEffect } from 'react';
import { compose } from "modules/core";
import PocReprtListView from "modules/poc-dashboard/components/poc_report/pocReportListView";
import { withApollo } from '@apollo/client/react/hoc';
import { GET_SURVEY_REPORT_URL, ORG_POC_SURVEYS, ORG_POC_SURVEY_EMPLOYEE_RESPONSE_SET, ORG_POC_SURVEY_EMPLOYEE_RESPONSE_SET_DATE_RANGE, ORG_POC_SURVEY_EMPLOYEE_RESPONSE_SET_NON_360, ORG_POC_SURVEY_EMPLOYEE_RESPONSE_SET_NON_360_DATE_RANGE, QUERY_FOR_EXPORT_360_SURVEY_DETAILED_REPORT, VERTICAL_LIST, VERTICAL_WISE_SURVEY_RESPONSES, VERTICAL_WISE_SURVEY_RESPONSES_NON_360 } from "modules/poc-dashboard/graphql/pocDashboardQuery.gql";
import { VALUE_SUERVEY_PART_1, PERSONALITY_PART_1, STRENGTH_PART_1, KNOWLEDGE_PART_1, grow_survey_id, SURVEY_READINESS_LEVEL, feedback_survey_id, feedback_1_1_survey_id, USER_MANUAL_SURVEY_ID, effectiveness_indicator_one_on_one, SURVEY_DIVERSITY_PROFILE, SURVEY_ID_3CS, VALUE_SUERVEY_PART_2, PERSONALITY_PART_2, STRENGTH_PART_2, KNOWLEDGE_PART_2, cc_graduation_test, EFFECTIVE_WORK_COMMUNICATION } from '../../../../config';
import { Capitalize, displayUtcToUserTimezone, exportToCsv, exportToExcel, getIntFromString, globalPermissionValidator } from 'modules/look';
import NoPermissionView from 'modules/kudos-user/component/NoPermissionComponent';
import { poc_admin_permission } from 'Permissions/poc_admin.permission';
import { message, Spin } from 'antd';
import moment from 'moment';
import gql from 'graphql-tag';
import am_dashboard_routes from 'modules/poc-dashboard/account-manager/routes';
import { getOrgID } from '../organization/organizationOperations';
import poc_dashboard_routes from 'modules/poc-dashboard/routes';
import { ORG_POC_360_TOKEN_INVITE } from "modules/poc-dashboard/graphql/tokenQuery.gql";
import { SURVEY_RESPONSE_SUBSCRIPTION } from 'modules/poc-dashboard/graphql/survey-response-subscription.gql';


const PocReportListContainer = (props) => {
    const { me, client, userPermission, location, orgToFetchData } = props;
    const [org_survey_lists, setSurveyList] = useState([]);
    const [selected_survey_response, setSurveyResponseSet] = useState();
    const [table_data_loading, setTableDataLoading] = useState(true);
    const [total_score, setTotalScore] = useState(0)
    const [response_page_info, setReasponsePageInfo] = useState()
    const response_data_ref = React.useRef([])
    const [permission, setPermission] = React.useState()
    const [survey_list_loading, setSurveyListLoading] = React.useState(true)
    const [export_loader, SetExportLoader] = React.useState(false)
    const [download_progress, SetDownloadProgress] = React.useState(0)
    const [vertical_list, setVerticalList] = React.useState([])
    let download_progress_ref = React.useRef(0)
    const survey_response_subscription_ref = React.useRef(null);

    const [selectedResponses, setSelectedResponses] = React.useState([]);
    const [selectedInviteeResponses, setSelectedInviteeResponses] = React.useState([]);
    const [reminderLoading, setReminderLoading] = React.useState(false);
    const [all_invitees_list, set_all_invitees_list] = useState([]);

    const [survey_id, setSurveyId] = useState([]);
    const [filter_obj, setFilter_obj] = useState([]);
    const [invitees_list_loading, setInviteesListLoading] = useState(false)


    React.useEffect(() => {
        if (filter_obj?.is_360 && survey_id) {
            getSurveyTokenList({})
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [survey_id, orgToFetchData, filter_obj])



    const getSurveyTokenList = async (filterData = {}, accumulatedList = []) => {
        try {
            setInviteesListLoading(true);
            const { data } = await client.query({
                query: ORG_POC_360_TOKEN_INVITE,
                variables: {
                    ...filterData,
                    first: 100,
                    orgId: getOrgID(props) || orgToFetchData?.id,
                    survey: survey_id,
                    valid: true
                },
                fetchPolicy: 'network-only'
            });
            // Flatten the edges: pull `node` contents out to top level
            const flattenedEdges = data.tokenListByOrgId.edges.map(edge => ({
                cursor: edge.cursor,
                ...edge.node
            }));

            const combinedList = accumulatedList.concat(flattenedEdges);

            if (data.tokenListByOrgId.pageInfo?.hasNextPage) {
                await getSurveyTokenList(
                    { ...filterData, after: data.tokenListByOrgId.pageInfo.endCursor },
                    combinedList
                );
            } else {
                set_all_invitees_list(prev => [...prev, ...combinedList]);
                setInviteesListLoading(false);
            }
        } catch (error) {
            setInviteesListLoading(false);
            console.error("Failed to fetch tokens:", error);
        }
    };



    // end here
    const handleSendReminders = async (reminderData) => {
        if (!reminderData?.length) return;

        setReminderLoading(true);

        try {
            const ALL_REMINDER = gql`
                query remindUserSurveyById {
                    ${reminderData?.map((item, index) =>
                `query_${index}: remindUserSurveyById(id:${item?.id}, usr:${item?.usr}, tlink:"${item?.tlink}")`
            ).join('')}
                }
            `;

            await client.query({
                query: ALL_REMINDER,
                fetchPolicy: 'network-only'
            });

            message.success('Reminders sent successfully');
            setSelectedResponses([]);
            setSelectedInviteeResponses([]);
        } catch (error) {
            console.error("pocReportListContainer -> handleSendReminders", JSON.stringify(error, null, 2));
            message.error('Failed to send reminders: ' + (error.message || 'Unknown error'));
        } finally {
            setReminderLoading(false);
        }
    };



    React.useEffect(() => {
        response_data_ref.current = selected_survey_response
    }, [selected_survey_response])

    React.useEffect(() => {
        if (userPermission?.length && me) {
            let permissions = globalPermissionValidator(poc_admin_permission, userPermission)
            if (permissions?.required_permission && !me?.employee?.orgAmEmployee?.totalCount) {
                if (permissions.required_permission && !me?.employee?.orgPocEmployee?.totalCount) {
                    permissions.required_permission = false
                }
                if (permissions.required_permission && !me?.employee?.organizationSet?.edges?.length) {
                    permissions.required_permission = false
                }
                if (permissions.required_permission && Object.values(am_dashboard_routes).some(routes => location?.pathname.includes(routes))) {
                    permissions.required_permission = false
                }
            } else if (me?.employee?.orgAmEmployee?.totalCount && !me?.employee?.orgPocEmployee?.totalCount) {
                if (permissions.required_permission && Object.values(poc_dashboard_routes).some(routes => location?.pathname.includes(routes))) {
                    permissions.required_permission = false
                }
            }
            if (JSON.stringify(permissions) !== JSON.stringify(permission)) {
                setPermission(permissions)
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userPermission, me])

    useEffect(() => {
        if (orgToFetchData?.id || getOrgID(props)) {
            verticalList()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [orgToFetchData])

    useEffect(() => {
        if (permission?.required_permission && (orgToFetchData?.id || getOrgID(props))) {
            getOrgSurveyList();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [permission, orgToFetchData]);

    const getOrgSurveyList = async () => {
        setSurveyListLoading(true)
        const { data } = await client.query({
            query: ORG_POC_SURVEYS,
            fetchPolicy: 'network-only',
            variables: {
                id: getOrgID(props) || orgToFetchData?.id
            }
        });
        if (data?.organizationById?.surveySet) {
            let skip_survey = [VALUE_SUERVEY_PART_1, VALUE_SUERVEY_PART_2, PERSONALITY_PART_1, PERSONALITY_PART_2, STRENGTH_PART_1, STRENGTH_PART_2, KNOWLEDGE_PART_1, KNOWLEDGE_PART_2, grow_survey_id, SURVEY_READINESS_LEVEL, feedback_survey_id, feedback_1_1_survey_id, USER_MANUAL_SURVEY_ID, effectiveness_indicator_one_on_one, SURVEY_DIVERSITY_PROFILE, SURVEY_ID_3CS]
            let list_after_skip = data?.organizationById?.surveySet?.edges?.filter(({ node }) => !skip_survey.includes(getIntFromString(node?.id)))
            setSurveyList(list_after_skip?.map(({ node }) => {
                return {
                    ...node,
                    max_score: calculateMaxScore(node?.groupSet?.edges)
                }
            }));
            setSurveyListLoading(false)
        }
        if (!data?.organizationById?.surveySet?.edges?.length) {
            setTableDataLoading(false)
        }
    };

    const calculateMaxScore = (data) => {
        let questions_in_group = data?.map(({ node }) => node?.questionSet?.totalCount || 0)
        let total_grade = 0;
        try {
            let greadings_edges = data?.map(({ node }) => node?.questionSet?.edges || []).flat();
            let grading_parameters = greadings_edges?.map(ele => ele?.node?.gradingParameters)
            grading_parameters.forEach(ele => {
                if (ele === null)
                    throw new Error("Grading parameters are null")
                else {
                    Object.values(JSON.parse(ele)).forEach(ele => total_grade += Number(ele))
                }
            });
        } catch (error) {
            total_grade = 0;
        }

        return total_grade > 0 ? total_grade : questions_in_group?.reduce((a, b) => a + b, 0)
    }

    const checkTotalScore = (value) => {
        try {
            let answerSet = value?.edges?.map(({ node }) => node)
            let question_ids = [...new Set(answerSet?.map(i => i?.question?.id))]
            let total_score = 0
            let total_grade = 0
            question_ids.forEach(q => {
                let list_answer = answerSet?.filter(a => a?.question?.id === q)
                let choice_set = list_answer[0]?.question?.choiceSet?.edges?.map(({ node }) => node)
                let user_answer = list_answer?.map(ans => ans?.answer)?.flatMap(item => item.split(','))
                let correct_answers = choice_set?.filter(cw => cw?.answerKey)?.map(i => i?.value)
                let user_input_is_correct = !correct_answers?.length ? false : correct_answers?.some(i => user_answer?.includes(i))
                if (user_input_is_correct) {
                    total_score = total_score + 1
                }
                let grades = 0;
                if (list_answer?.[0]?.gradingParametersAnswers) {
                    try {
                        const gradeObj = JSON.parse(list_answer?.[0]?.gradingParametersAnswers)
                        if (gradeObj) {
                            Object.values(gradeObj).forEach(ele => {
                                grades += Number(ele)
                            })
                        } else {
                            grades = user_input_is_correct ? "1" : "0"
                        }
                    } catch (error) {
                        grades = user_input_is_correct ? "1" : "0"
                    }
                }
                if (grades) {
                    total_grade += grades
                }
            })
            const selectedSurvey = localStorage.getItem("selected_survey_response")
            let surveyId = null
            if (selectedSurvey) {
                surveyId = JSON.parse(selectedSurvey)?.id;
            }
            total_score = !EFFECTIVE_WORK_COMMUNICATION.includes(getIntFromString(surveyId))
                ? total_score
                : total_grade
            setTotalScore(total_score)
            return total_score
        } catch (error) {
            console.error("pocReportListContainer -> checkTotalScore", error)
            return 0
        }
    }

    const allEmployee360SurveyResponse = async (filter) => {
        try {
            setTableDataLoading(true)
            const { data } = await client.query({
                query: ORG_POC_SURVEY_EMPLOYEE_RESPONSE_SET,
                variables: { ...filter, first: 10, orderBy: ["user__firstName"], id: getOrgID(props) || orgToFetchData?.id },
                fetchPolicy: 'network-only'
            });
            if (data?.organizationById?.employees) {

                let list = data?.organizationById?.employees?.edges?.flatMap(({ node }) => handleEmployeeData(node))
                setReasponsePageInfo({
                    hasNextPage: data?.organizationById?.employees?.pageInfo?.hasNextPage,
                    after: data?.organizationById?.employees?.pageInfo?.endCursor
                })
                if (filter?.after) {
                    list = response_data_ref?.current.concat(list)
                }
                setSurveyResponseSet(list)
                setTableDataLoading(false)
            }

        } catch (error) {
            console.error("pocReportListContainer -> allEmployee360SurveyResponse", error)
        }
    }

    const allEmployeeNon360SurveyResponse = async (filter) => {
        try {
            setTableDataLoading(true)
            const { data } = await client.query({
                query: ORG_POC_SURVEY_EMPLOYEE_RESPONSE_SET_NON_360,
                variables: { ...filter, first: 10, orderBy: ["user__firstName"], id: getOrgID(props) || orgToFetchData?.id },
                fetchPolicy: 'network-only'
            });
            if (data?.organizationById?.employees) {
                setReasponsePageInfo({
                    hasNextPage: data?.organizationById?.employees?.pageInfo?.hasNextPage,
                    after: data?.organizationById?.employees?.pageInfo?.endCursor
                })
                let list = data?.organizationById?.employees?.edges?.flatMap(({ node }) => handleEmployeeData(node))


                let data_list = filter?.after ? response_data_ref?.current.concat(list) : list
                setSurveyResponseSet(data_list)
                setTableDataLoading(false)
            }
        } catch (error) {
            console.error("PocReportListContainer -> allEmployeeNon360SurveyResponse", error)
        }
    }

    const allEmployee360SurveyResponseDateRange = async (filter) => {
        try {
            setTableDataLoading(true)
            const { data } = await client.query({
                query: ORG_POC_SURVEY_EMPLOYEE_RESPONSE_SET_DATE_RANGE,
                variables: { ...filter, first: 10, orderBy: ["user__firstName"] },
                fetchPolicy: 'network-only'
            });
            if (data?.SurveyById?.responseSet) {

                let list = data?.SurveyById?.responseSet?.edges?.flatMap(({ node }) => handleEmployeeData(node))
                setReasponsePageInfo({
                    hasNextPage: data?.SurveyById?.responseSet?.pageInfo?.hasNextPage,
                    after: data?.SurveyById?.responseSet?.pageInfo?.endCursor
                })
                if (filter?.after) {
                    list = response_data_ref?.current?.concat(list)
                }
                setSurveyResponseSet(list)
                setTableDataLoading(false)
            }

        } catch (error) {
            console.error("pocReportListContainer -> allEmployee360SurveyResponseDateRange", error)
        }
    }

    const allEmployeeNon360SurveyResponseDateRange = async (filter) => {
        try {
            setTableDataLoading(true)
            const { data } = await client.query({
                query: ORG_POC_SURVEY_EMPLOYEE_RESPONSE_SET_NON_360_DATE_RANGE,
                variables: { ...filter, first: 10, orderBy: ["user__firstName"] },
                fetchPolicy: 'network-only'
            });
            if (data?.SurveyById?.responseSet) {
                setReasponsePageInfo({
                    hasNextPage: data?.SurveyById?.responseSet?.pageInfo?.hasNextPage,
                    after: data?.SurveyById?.responseSet?.pageInfo?.endCursor
                })
                let list = data?.SurveyById?.responseSet?.edges?.flatMap(({ node }) => handleEmployeeData(node))


                let data_list = filter?.after ? response_data_ref?.current?.concat(list) : list
                setSurveyResponseSet(data_list)
                setTableDataLoading(false)
            }
        } catch (error) {
            console.error("pocReportListContainer -> allEmployeeNon360SurveyResponseDateRange", error)
        }
    }

    const verticalEmployee360SurveyResponse = async (filter) => {
        try {
            setTableDataLoading(true)
            const { data } = await client.query({
                query: VERTICAL_WISE_SURVEY_RESPONSES,
                variables: { ...filter, first: 10, organization: getOrgID(props) || orgToFetchData?.id },
                fetchPolicy: 'network-only'
            });
            if (data?.verticals?.edges?.[0]?.node?.employees || data?.verticals?.edges?.[0]?.node?.heads) {

                let list = [
                    ...data?.verticals?.edges?.[0]?.node?.employees?.edges?.flatMap(({ node }) => handleEmployeeData(node)),
                    ...data?.verticals?.edges?.[0]?.node?.heads?.edges?.flatMap(({ node }) => handleEmployeeData(node))
                ]
                setReasponsePageInfo({
                    hasNextPage: data?.verticals?.edges?.[0]?.node?.employees?.pageInfo?.hasNextPage,
                    after: data?.verticals?.edges?.[0]?.node?.employees?.pageInfo?.endCursor
                })
                if (filter?.after) {
                    list = response_data_ref?.current?.concat(list)
                }
                setSurveyResponseSet(list)
                setTableDataLoading(false)
            }

        } catch (error) {
            console.error("pocReportListContainer -> verticalEmployee360SurveyResponse", error)
        }
    }

    const verticalEmployeeNon360SurveyResponse = async (filter) => {
        try {
            setTableDataLoading(true)
            const { data } = await client.query({
                query: VERTICAL_WISE_SURVEY_RESPONSES_NON_360,
                variables: { ...filter, first: 10, organization: getOrgID(props) || orgToFetchData?.id },
                fetchPolicy: 'network-only'
            });
            if (data?.verticals?.edges?.[0]?.node?.employees || data?.verticals?.edges?.[0]?.node?.heads) {
                setReasponsePageInfo({
                    hasNextPage: data?.verticals?.edges?.[0]?.node?.employees?.pageInfo?.hasNextPage,
                    after: data?.verticals?.edges?.[0]?.node?.employees?.pageInfo?.endCursor
                })
                let list = [
                    ...data?.verticals?.edges?.[0]?.node?.employees?.edges?.flatMap(({ node }) => handleEmployeeData(node)),
                    ...data?.verticals?.edges?.[0]?.node?.heads?.edges?.flatMap(({ node }) => handleEmployeeData(node))
                ]


                let data_list = filter?.after ? response_data_ref?.current?.concat(list) : list
                setSurveyResponseSet(data_list)
                setTableDataLoading(false)
            }
        } catch (error) {
            console.error("pocReportListContainer -> verticalEmployeeNon360SurveyResponse", error)
        }
    }

    const verticalList = async () => {
        try {
            const { data } = await client.query({
                query: VERTICAL_LIST,
                variables: { organization: getOrgID(props) || orgToFetchData?.id },
                fetchPolicy: 'network-only'
            });
            if (data?.verticals?.edges?.length) {
                setVerticalList(data?.verticals?.edges?.map(({ node }) => ({ type: node?.name, key: node?.id })))
            }
        } catch (error) {
            console.error("pocReportListContainer -> verticalList", error)
        }
    }

    const handleEmployeeData = (node) => {
        let user_responses = node?.user?.responseSet?.edges?.map(r => r?.node)
        if (user_responses?.length) {
            return user_responses?.map(res => {
                return {
                    user_id: node?.user?.id,
                    firstName: Capitalize(node?.user?.firstName),
                    lastName: Capitalize(node?.user?.lastName),
                    email: node?.user?.email,
                    response_id: res?.id,
                    responseDate: res?.responseDate,
                    responseSource: node?.user?.responseSet?.edges?.[0]?.node?.id,
                    vertical: node?.user?.employee ? [...new Set([
                        ...node?.user?.employee?.verticalMembersEmployee?.edges?.map(({ node }) => node?.name),
                        ...node?.user?.employee?.verticalHeadEmployee?.edges?.map(({ node }) => node?.name)]
                    )] : [],
                    total_invitation: res?.total_invitation?.totalCount,
                    completed_invitation: res?.completed_invitation?.totalCount,
                    totalScore: res?.answerSet?.edges?.length ? checkTotalScore(res?.answerSet) : 0,
                    multiSourceResponse: res?.multisourceResponseSet?.edges?.map(node => node),
                }
            })
        } else {
            return [
                {
                    user_id: node?.user?.id,
                    firstName: Capitalize(node?.user?.firstName),
                    lastName: Capitalize(node?.user?.lastName),
                    email: node?.user?.email,
                    response_id: null,
                    responseDate: null,
                    responseSource: node?.user?.responseSet?.edges?.[0]?.node?.id,
                    vertical: node?.user?.employee ? [...new Set([
                        ...node?.user?.employee?.verticalMembersEmployee?.edges?.map(({ node }) => node?.name),
                        ...node?.user?.employee?.verticalHeadEmployee?.edges?.map(({ node }) => node?.name)]
                    )] : [],
                    total_invitation: 0,
                    completed_invitation: 0,
                    totalScore: 0
                }
            ]
        }
    }

    const sortScore = (type) => {
        setTableDataLoading(true)
        let result = [...selected_survey_response]
        if (type === 'ascending') {
            result = result.sort((a, b) => a?.totalScore - b?.totalScore);
        } else if (type === 'descending') {
            result = result.sort((a, b) => b?.totalScore - a?.totalScore);
        }
        setTableDataLoading(false)
        setSurveyResponseSet(result)
    }

    let ref_360DownloadData = React.useRef({
        employee_list: [],
        invitation_list: []
    })

    React.useEffect(() => {
        download_progress_ref.current = download_progress
    }, [download_progress])


    const GetDataForcsvOf360Survey = async (filter) => {
        try {
            SetExportLoader(true)
            const { data } = await client.query({
                query: QUERY_FOR_EXPORT_360_SURVEY_DETAILED_REPORT,
                variables: { survey: getIntFromString(filter?.survey), id: getIntFromString(getOrgID(props) || orgToFetchData?.id) },
                fetchPolicy: 'network-only'
            });
            if (data) {
                GenerateExcelFor360(data, filter?.survey_name)
            }
        } catch (error) {
            resetDownload()
            message.error("Failed to download")
            console.error("pocReportListContainer -> GetDataForcsvOf360Survey", error)
        }
    }

    const GenerateExcelFor360 = (data, survey_name) => {
        try {
            if (data) {
                exportToExcel(`MApp_${survey_name}_360_report_${moment()}`, data, survey_name)
                resetDownload()
                message.success("Report has been exported")
            } else {
                resetDownload()
                message.error("No data available")
            }

        } catch (error) {
            resetDownload()
            message.error("Failed to download")
            console.error("pocReportListContainer -> GenerateExcelFor360", error)
        }
    }

    let ref_Non360DownloadData = React.useRef({
        employee_list: [],
    })

    const GetSurveyExportURL = async (filter) => {
        if (!survey_response_subscription_ref.current) {
            try {
                surveyResponseSubscription();
                SetExportLoader(true)
            } catch (error) {
                console.error("pocReportListContainer -> GetSurveyExportURL", error);
            }
        }
        await client.query({
            query: GET_SURVEY_REPORT_URL,
            variables: filter,
            fetchPolicy: 'network-only'
        });
    }

    const surveyResponseSubscription = (task_id) => {
        survey_response_subscription_ref.current = client.subscribe({
            query: SURVEY_RESPONSE_SUBSCRIPTION,
        }).subscribe({
            next(result) {
                let sub_data = result?.data?.exportStatusSubscription;
                switch (sub_data?.mutation) {
                    case 'FILE':
                        const link = document.createElement('a');
                        link.href = sub_data?.filePath;
                        link.download = sub_data?.filePath.split('/').pop();
                        link.style.display = 'none';
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        if (survey_response_subscription_ref.current !== null) {
                            survey_response_subscription_ref.current.unsubscribe();
                            survey_response_subscription_ref.current = null;
                        }
                        SetExportLoader(false)
                        break;
                    default:
                        console.error("Subscription not handled for ", sub_data.mutation)
                }
            }
        });
    }

    const GetDataForcsvOfNon360Survey = async (filter) => {
        try {
            SetExportLoader(true)
            let doc_per_page = 100
            let current_page = filter?.page || 1
            let offset = (current_page - 1) * doc_per_page
            const { data } = await client.query({
                query: ORG_POC_SURVEY_EMPLOYEE_RESPONSE_SET_NON_360,
                variables: { survey: filter?.survey, first: doc_per_page, offset, orderBy: ["user__firstName"], id: getOrgID(props) || orgToFetchData?.id },
                fetchPolicy: 'network-only'
            });
            if (data) {
                let max_doc = data?.organizationById?.employees?.totalCount
                let total_page = Math.ceil(max_doc / doc_per_page)
                let progress = download_progress_ref.current + (100 / total_page)
                SetDownloadProgress(Math.round(progress))
                let has_next_page = data?.organizationById?.employees?.pageInfo?.hasNextPage
                ref_Non360DownloadData.current.employee_list = ref_Non360DownloadData.current.employee_list.concat(data?.organizationById?.employees?.edges?.map(({ node }) => node))
                if (has_next_page) {
                    GetDataForcsvOfNon360Survey({
                        ...filter,
                        page: current_page + 1
                    })
                } else {
                    GenerateCSVForNon360(ref_Non360DownloadData.current, filter?.survey_name, filter?.survey)
                }
            }

        } catch (error) {
            resetDownload()
            message.error("Failed to download")
            console.error("pocReportListContainer -> GetDataForcsvOfNon360Survey", error)
        }
    }

    const GenerateCSVForNon360 = (data, survey_name, survey_id) => {
        try {
            let employee_list_response = data?.employee_list?.flatMap(node => handleEmployeeData(node))


            let csv_data = []

            if (cc_graduation_test.includes(getIntFromString(survey_id))) {
                let survey_detail = org_survey_lists?.find(i => getIntFromString(i?.id) === getIntFromString(survey_id))

                csv_data = employee_list_response?.map((i, index) => {
                    let data = {
                        "Sr.No": index + 1,
                        "Name": `${i?.firstName} ${i?.lastName || ""}`,
                        "Email": i?.email,
                        "Vertical": i?.vertical?.length ? i?.vertical?.join(", ") : " ",
                        "Response Date": i?.responseDate ? displayUtcToUserTimezone(i?.responseDate, 'MMM DD YYYY, hh:mm') : " ",
                        "Status": i?.response_id ? "Completed" : "Pending"
                    }
                    if (survey_detail) {
                        data[`Score (Maximum Score: ${survey_detail?.max_score})`] = i?.response_id ? i?.totalScore : " "
                    } else {
                        data[`Score`] = i?.response_id ? i?.totalScore : " "
                    }
                    return data
                })

            } else {
                csv_data = employee_list_response?.map((i, index) => {
                    return {
                        "Sr.No": index + 1,
                        "Name": `${i?.firstName} ${i?.lastName || ""}`,
                        "Email": i?.email,
                        "Vertical": i?.vertical?.length ? i?.vertical?.join(", ") : " ",
                        "Response Date": i?.responseDate ? displayUtcToUserTimezone(i?.responseDate, 'MMM DD YYYY, hh:mm') : " ",
                        "Status": i?.response_id ? "Completed" : "Pending"
                    }
                })
            }
            if (csv_data?.length) {
                exportToCsv(`MApp_${survey_name}_report_${moment()}`, csv_data)
                resetDownload()
                message.success("Report has been exported")
            } else {
                resetDownload()
                message.error("No data available")
            }

        } catch (error) {
            resetDownload()
            message.error("Failed to download")
            console.error("pocReportListContainer -> GenerateCSVForNon360", error)
        }
    }

    const resetDownload = () => {
        ref_360DownloadData.current = {
            employee_list: [],
            invitation_list: []
        }
        ref_Non360DownloadData.current = {
            employee_list: [],
        }
        SetDownloadProgress(0)
        SetExportLoader(false)
    }

    return (
        <>
            {(permission && !permission?.required_permission) && (<NoPermissionView />)}
            {
                (permission && permission?.required_permission) && (
                    <PocReprtListView org_survey_lists={org_survey_lists}
                        selected_survey_response={selected_survey_response}
                        table_data_loading={table_data_loading}
                        sortScore={(type) => sortScore(type)}
                        total_score={total_score}
                        response_page_info={response_page_info}
                        survey_list_loading={survey_list_loading}
                        allEmployeeNon360SurveyResponse={allEmployeeNon360SurveyResponse}
                        verticalEmployee360SurveyResponse={verticalEmployee360SurveyResponse}
                        allEmployeeNon360SurveyResponseDateRange={allEmployeeNon360SurveyResponseDateRange}
                        allEmployee360SurveyResponse={allEmployee360SurveyResponse}
                        verticalEmployeeNon360SurveyResponse={verticalEmployeeNon360SurveyResponse}
                        allEmployee360SurveyResponseDateRange={allEmployee360SurveyResponseDateRange}
                        GetDataForcsvOf360Survey={GetDataForcsvOf360Survey}
                        export_loader={export_loader}
                        download_progress={download_progress}
                        setSurveyResponseSet={setSurveyResponseSet}
                        GetDataForcsvOfNon360Survey={GetDataForcsvOfNon360Survey}
                        verticalList={vertical_list}
                        selectedResponses={selectedResponses}
                        setSelectedResponses={setSelectedResponses}
                        selectedInviteeResponses={selectedInviteeResponses}
                        setSelectedInviteeResponses={setSelectedInviteeResponses}
                        reminderLoading={reminderLoading}
                        handleSendReminders={handleSendReminders}
                        setSurveyId={setSurveyId}
                        all_invitees_list={all_invitees_list}
                        set_all_invitees_list={set_all_invitees_list}
                        setFilter_obj={setFilter_obj}
                        invitees_list_loading={invitees_list_loading}
                        survey_id={survey_id}
                        GetSurveyExportURL={GetSurveyExportURL}
                        {...props} />
                )
            }
            {
                !permission && (
                    <div className="role-no-permission-container">
                        <Spin spinning={true} size="large"></Spin>
                    </div>
                )
            }

        </>
    );
};

export default compose(withApollo)(PocReportListContainer);
